import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLinkWithHref } from '@angular/router';

import { IonButton } from '@ionic/angular/standalone';

@Component({
    selector: 'lib-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: true,
    imports: [IonButton, CommonModule, RouterLinkWithHref]
})
export class ButtonComponent {
    /* eslint-disable */
    @Input() expand: boolean = true;
    @Input() routerLink!: string | any[];
    @Input() href!: string;
    @Input() extraVerticalPadding: boolean = true;
    @Input() type: 'button' | 'reset' | 'submit' = 'button';
    @Input() fill: 'clear' | 'default' | 'outline' | 'solid' | undefined = 'solid';
    @Input() disabled: boolean = false;
    @Input() readonly: boolean = false;
    @Input() borderStyle: 'solid' | 'dashed' | 'none' | 'input' = 'solid';
    @Input() classes: string | undefined = '';
    @Input() displayAsInlineText: boolean = false;
    @Input() inlineTextNoTransform: boolean = false;
    @Input() inlineTextColor: 'dark' | 'primary' | string = 'primary';
    @Input() color:
        | 'danger'
        | 'dark'
        | 'light'
        | 'medium'
        | 'primary'
        | 'secondary'
        | 'success'
        | 'tertiary'
        | 'warning'
        | string
        | undefined = undefined;

    @Output() onClick = new EventEmitter();

    inlineTextColorMap: { [key: string]: string } = {
        dark: 'var(--ion-color-dark)',
        primary: 'var(--ion-color-orange)'
    };

    onButtonClick() {
        if (this.disabled || this.readonly) return;
        this.onClick.emit();
    }
}
